<template>
<div class="container v-content-container">
    <div class="row">
        <div class="col-xs-12">
            <h1>
                <i class="fa fa-fw fa-lg fa-home"></i>{{ $label('operator.operator') }}: {{ operatorName }}
                <select v-model="selectedOperatorId" class="form-control course-select pull-right" style="margin-right: 15px;">
                    <option v-for="operator in operators.data" :value="operator.id">{{ operator.name }}</option>
                </select>
            </h1>
        </div>
    </div>

    <navigation-tabs :operator-id="selectedOperatorId"></navigation-tabs>

    <div v-show="loading" class="row">
        <div class="col-xs-12">
            <view-loader margin-top-pixels="15"></view-loader>
        </div>
    </div>

    <div v-show="!loading" class="row">
        <div class="col-sm-12">
            <invoice-details :operator-id="selectedOperatorId" :updating="updating"></invoice-details>
        </div>
    </div>

    <div v-show="!loading" class="row">
        <div class="col-sm-6">
            <div class="row">
                <div class="col-xs-12">
                    <bank-account :parent-resource-id="selectedOperatorId"
                        :parent-resource-path="bankAccountResourcePath"
                        :component-parent-view="viewName"
                        :updating="updating">
                    </bank-account>
                </div>
                <div class="col-xs-12">
                    <contact-person :parent-resource-id="selectedOperatorId"
                        :parent-resource-path="contactPersonResourcePath"
                        :component-parent-view="viewName"
                        :updating="updating">
                    </contact-person>
                </div>
            </div>
        </div>
        <div class="col-sm-6 tooltip-wrapper">
            <invoice-logo :operator-id="selectedOperatorId" :component-parent-view="viewName"></invoice-logo>
        </div>
    </div>


    <div v-show="!loading" class="row">
        <div class="col-xs-12">
            <invoice-prefixes-table :operator-id="selectedOperatorId"></invoice-prefixes-table>
        </div>
    </div>

    <div v-show="!loading" class="row"><div class="col-xs-12">&nbsp;</div></div>
    <hr v-show="!loading">

    <div v-show="!loading" class="row">
        <div class="col-xs-2 col-xs-offset-5 text-center">
            <info-button :text="$label('common.save')" :is-loading="updating" :click-action="startUpdating"></info-button>
        </div>
    </div>

    <div v-show="!loading" class="row"><div class="col-xs-12">&nbsp;</div></div>
</div>
</template>

<script>
import Api from '@/api';
import ViewStatus from '@/mixins/ViewStatus.js';
import Alerts from '@/mixins/Alerts.js';

import InfoButton from '@/components/Common/Buttons/InfoButton.vue';
import ViewLoader from '@/components/ViewLoader.vue'

import NavigationTabs from '@/components/Operator/NavigationTabs.vue';
import ContactPerson from '@/components/Common/Models/ContactPerson.vue';
import BankAccount from '@/components/Common/Models/BankAccount.vue';

import InvoiceDetails from '@/components/Operator/InvoiceSettings/InvoiceDetails.vue';
import InvoiceLogo from '@/components/Operator/InvoiceSettings/InvoiceLogo.vue';

// import BankDetails from '@/components/Operator/InvoiceSettings/BankDetails.vue';
// import ContactPersonDetails from '@/components/Operator/InvoiceSettings/ContactPersonDetails.vue';
import InvoicePrefixesTable from '@/components/Operator/InvoiceSettings/InvoicePrefixesTable.vue';
import InvoiceAdditionalText from '@/components/Operator/InvoiceSettings/InvoiceAdditionalText.vue';

export default {
    mixins: [ViewStatus, Alerts],

    components: {
        NavigationTabs,
        ViewLoader,
        InvoiceDetails,
        InfoButton,
        ContactPerson,
        BankAccount,
        //
        // BankDetails,
        // ContactPersonDetails,
        InvoicePrefixesTable,
        InvoiceLogo,
        InvoiceAdditionalText,
    },

    data() {
        return {
            operators: [],
            selectedOperatorId: null,
            viewName: 'operatorInvoiceSettings',
            loadConfirmations: {
                'billingSetting': {
                    timesRequired: 1,
                    timesReceived: 0,
                },
                'bankAccount': {
                    timesRequired: 1,
                    timesReceived: 0,
                },
                'contactPerson': {
                    timesRequired: 1,
                    timesReceived: 0,
                },
                'phoneNumber': {
                    timesRequired: 1,
                    timesReceived: 0,
                },
                'logo': {
                    timesRequired: 1,
                    timesReceived: 0,
                },
            },

            updateConfirmations: {
                'billingSetting': {
                    timesRequired: 1,
                    timesReceivedSuccessful: 0,
                    timesReceivedFailed: 0,
                },
                'bankAccount': {
                    timesRequired: 1,
                    timesReceivedSuccessful: 0,
                    timesReceivedFailed: 0,
                },
                'contactPerson': {
                    timesRequired: 1,
                    timesReceivedSuccessful: 0,
                    timesReceivedFailed: 0,
                },
                'phoneNumber': {
                    timesRequired: 1,
                    timesReceivedSuccessful: 0,
                    timesReceivedFailed: 0,
                },
                'logo': {
                    timesRequired: 1,
                    timesReceivedSuccessful: 0,
                    timesReceivedFailed: 0,
                },
            },
        };
    },

    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.selectedOperatorId = vm.$route.params.id;
            vm.startLoading();
            vm.getOperators();
        });
    },

    beforeRouteUpdate(to, from, next) {
        this.startLoading();
        this.getOperators();
        next();
    },

    mounted() {
        this.listenEvents();
    },

    methods: {
        getOperators() {
            let endpoint = this.$partnerEndpoint('operators');

            Api().get(endpoint)
                .then((response) => {
                    this.operators = response.data;
                })
                .catch((error) => {
                    //
                });
        },

        goToOperatorInvoiceSettings(operatorId) {
            if (this.selectedOperatorId !== operatorId) {
                this.selectedOperatorId = operatorId;
            }

            this.$router.push({
                name: 'operatorInvoiceSettings',
                params: { id: operatorId }
            });
        },

        listenEvents() {
            Event.$on(this.everythingUpdatedSuccessfulEventName, () => {
                this.successAlert('Success!', 'Operator details updated.');
            });
        },
    },

    computed: {
        /**
         * Returns the name of the current selected operator.
         */
        operatorName() {
            if (typeof this.operators.data === 'undefined' || this.operators.data.length < 1 || !this.selectedOperatorId) {
                return '-';
            }

            for (var i = 0; i < this.operators.data.length; i++) {
                if (this.operators.data[i].id == this.selectedOperatorId) {
                    return this.operators.data[i].name;
                }
            }

            return '-';
        },

        contactPersonResourcePath() {
            return 'operators/' + this.selectedOperatorId + '/billing-setting/';
        },

        bankAccountResourcePath() {
            return 'operators/' + this.selectedOperatorId + '/';
        },
    },

    watch: {
        selectedOperatorId(newOperatorId, oldOperatorId) {
            if (oldOperatorId !== null) {
                this.goToOperatorInvoiceSettings(newOperatorId);
            }
        },
    }
}
</script>
